import { useFeatures, type WorkspaceFeatures } from "@expert/features";

import type { ChallengeInfo } from "@/sales-tools/challenges/api/getChallengesForEmployee";

import { usePartnerConfig, usePartnerFeatureConfigured } from "@/partner/usePartnerConfig";
import { useChallenges } from "@/sales-tools/challenges/api/useChallenges";

function hasEnrollmentChallenge(challenge: ChallengeInfo | null | undefined) {
    if (challenge) {
        return challenge.challengeType === "solo" || challenge.challengeType === "team";
    }
}

export function useWidgetVisibility() {
    const {
        features: { isChallengeEnabled: isChallengeEnabledForExpert, isChecklistSummaryEnabled },
    } = useFeatures<WorkspaceFeatures>();
    const { isChallengesEnabled: isChallengesEnabledForPartner, isExpertPerformanceDashboardEnabled } =
        usePartnerFeatureConfigured();
    const { leaderboards } = usePartnerConfig();
    const { data: challengeData } = useChallenges();

    const hasLeaderboards = leaderboards.length > 0;
    const shouldHideWidgetContainer = !hasLeaderboards && !isChallengeEnabledForExpert;
    const showLeftPanel =
        (isChallengeEnabledForExpert && challengeData?.some(hasEnrollmentChallenge)) || hasLeaderboards;
    const showStatsHeader = isExpertPerformanceDashboardEnabled;
    const showChallenges = isChallengeEnabledForExpert && isChallengesEnabledForPartner;
    const showTrophyCase = isChallengeEnabledForExpert && isChallengesEnabledForPartner;

    return {
        shouldHideWidgetContainer,
        showLeftPanel,
        showStatsHeader,
        showChallenges,
        showTrophyCase,
        isChecklistSummaryEnabled,
        isExpertPerformanceDashboardEnabled,
        hasLeaderboards,
        leaderboards,
    };
}
